import { Link } from "react-router-dom";

const footerLinks = {
  探索: [
    { label: "日系风格", to: "/category?type=japanese" },
    { label: "韩系风格", to: "/category?type=korean" },
    { label: "欧美风格", to: "/category?type=european" },
    { label: "美式风格", to: "/category?type=american" },
  ],
  内容: [
    { label: "潮流文章", to: "/articles" },
    { label: "穿搭指南", to: "/articles" },
    { label: "趋势解读", to: "/articles" },
    { label: "单品推荐", to: "/articles" },
  ],
  关于: [
    { label: "品牌故事", to: "/about" },
    { label: "联系我们", to: "/about#contact" },
    { label: "常见问题", to: "/about#faq" },
    { label: "口碑评价", to: "/about#reputation" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-foreground-950">
                日韩欧美
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              日韩欧美风格一站式精选，汇聚国际潮流精华，为你打造专属时尚态度。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-300/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 日韩欧美 Style Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}